module.exports = __webpack_public_path__ + "b9eeedf69aa827c9c11705f2a919a4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/setup/browser/assets/upgrade_image_mobile.png
// module id = 5107
// module chunks = 25